export const PAYPAL_APP_FIELD = 'payPalAddress';
